import { groq } from "next-sanity"

import { AppSettings } from "@/settings"

import { checkPermissions } from "../../shared/permissions/permissions"
import { DomainObjects, Operations } from "../../shared/permissions/permissionsConfig"
import { tourScheduleProjection } from "../sanity/tourSchedule.projection"

export const queryTourSchedule = {
  async tourSchedule(parent, args, context, info) {
    const { lang = AppSettings.defaultLocale(), cdn = true, id } = args
    const { user } = context

    await checkPermissions({
      user,
      domainObject: DomainObjects.TOURS,
      operation: Operations.READ,
    })

    const config = AppSettings.sanityConfigByLang(lang)
    const client = context.sanityClient
    client.config({ ...config, useCdn: cdn })

    const draftsFilter = `&& !(_id in path("drafts.**"))`

    const tourSchedule = await client.fetch(
      groq`*[_type=="tourSchedule" && id==$id ${draftsFilter}][0]{
        ${tourScheduleProjection()}
      }`,
      { id: id },
    )

    if (tourSchedule) {
      return {
        ...tourSchedule,
        tours: [
          tourSchedule.tour01,
          tourSchedule.tour02,
          tourSchedule.tour03,
          tourSchedule.tour04,
          tourSchedule.tour05,
          tourSchedule.tour06,
          tourSchedule.tour07,
          tourSchedule.tour08,
        ],
      }
    }

    return null
  },
}
